import { render, staticRenderFns } from "./phaseSettings.vue?vue&type=template&id=69ad2705&scoped=true"
import script from "./phaseSettings.vue?vue&type=script&lang=js"
export * from "./phaseSettings.vue?vue&type=script&lang=js"
import style0 from "./phaseSettings.vue?vue&type=style&index=0&id=69ad2705&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad2705",
  null
  
)

export default component.exports